export default "__VITE_PUBLIC_ASSET__2fc8eb92__"